export class Settings {
  constructor() {
    this.earnings = null;
    this.commitments = null;
    this.directDebits = null;
    this.essentialSpends = null;
    this.alerts = null;
    this.essentialSpends = null;
  }
  getSettings() {
    return this;
  }
}

export default Settings;
